export default {
    ellipsize: (str, length, ellipsis = "\u2026") => {
        if (str.length < length) {
            return str;
        } else {
            return str.slice(0, length - ellipsis.length) + ellipsis;
        }
    }
};
